import { FormInputText } from './formInputs';


function SalesForceOppId(props: {defaultValue?: string}) {

  return (
    <FormInputText
      name="oppID"
      label="SalesForce Opportunity ID"
      defaultValue={props.defaultValue}
      pattern={{
        regex: /^006[a-zA-Z0-9]+$/,
        message: 'Invalid ID'
      }}
    />
  )
}

export default SalesForceOppId;
